//Imports
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'

//Setup Vue
Vue.config.productionTip = false

//Setup axios
Vue.prototype.axios = axios.create({
    baseURL: "/api/v1", //TODO: Put in conf
});
Vue.prototype.axios.interceptors.request.use(
    function(config) {
        //If present, add our auth token to API requests
        const authToken = store.getters['auth/getToken'];
        if(authToken !== null) config.headers['Authorization'] = 'Token ' + authToken;
        //append slash to url if not present (usefull for django APPEND_SLASH)
        if(config.url[config.url.length-1] !== '/') { config.url += '/'; }
        return config;
    },
    function(error){return Promise.reject(err);}
);
// Vue.prototype.axios.interceptors.response.use(
//     function(response){ return response;},
//     function(error){
//         if (error.response.status === 401) {
//             store.dispatch('auth/logout');
//             router.push({ name:'login' });
//         }
//         return Promise.reject(error);
//     }
// );

//Import root component
import App from './App.vue'

var VueScrollTo = require('vue-scrollto');
 Vue.use(VueScrollTo)

//Import component framework
// import Proto2 from '@/components/proto2'
// import '@/components/proto2/style/base.scss'
// Vue.use(Proto2);

//Create instance
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
